// // src/Components/PrivateRoute.jsx
// import React from "react";
// import { Navigate } from "react-router-dom";

// const PrivateRoute = ({ children }) => {
//   const token = localStorage.getItem("token");
//   if (!token) return <Navigate to="/" replace />;
//   return children;
// };

// export default PrivateRoute;


import React from "react";
import { Navigate } from "react-router-dom";

const PrivateRoute = ({ children }) => {
  const isAuthenticated = !!localStorage.getItem("StudentId"); 
  // Or check for token if you implement token-based auth

  return isAuthenticated ? children : <Navigate to="/login" replace />;
};

export default PrivateRoute;
